(ns frontend.ux-overhaul.view-configuration.common
  (:require
   [frontend.state.current-session :as session]))

(defonce view-configuration-path [:forms :view-configuration])

(defn get-tasks-default-filters-and-grouping
  "Logic requested by Mikko"
  []
  (let [tasks @session/tasks
        account-id @session/account-id

        my-pending-tasks (->> tasks
                              (filterv (fn [task]
                                         (and (= (:task/assignee task) account-id)
                                              (not (:task/completed? task))))))]
    (if (< 3 (count my-pending-tasks))
      (let [filters [{:field :task/assignee
                      :value account-id}
                     {:field :task/completed?
                      :value false}]
            group-by-attribute :task/completed?]
        [filters group-by-attribute])

      (let [all-pending-tasks (->> tasks
                                   (filterv (fn [task]
                                              (not (:task/completed? task)))))]
        (if (< 3 (count all-pending-tasks))
          (let [filters [{:field :task/completed?
                          :value false}]
                group-by-attribute :task/assignee]

            [filters group-by-attribute])

          [[] :task/assignee])))))

(defn get-default-view-config
  [entity-type]
  (let [[filters group-by-attribute] (get-tasks-default-filters-and-grouping)

        card-view {:view-settings {:sorting        {:sort-by        :common/created-on
                                                    :sort-direction :descending}
                                   :grouping       {:group-by group-by-attribute}
                                   :summary-footer {:show-summary? true
                                                    :content       [:total-count]}}
                   :card-settings {:look-and-feel    {:card-size          :large ; :compact || :medium || :large
                                                      :card-height        :medium
                                                      :card-width         :wide
                                                      :show-empty-fields? false ; true || false
                                                      :empty-field-placeholder "-"
                                                     }
                                   :color-coding     {:use-color-coding? false
                                                      :attribute         :owner
                                                      :operator          :is}
                                   :border-highlight {:use-for :rotting-entity}
                                   :card-header      {:display-name      :name ; :name || :alias
                                                      :card-header-value :entity-alias
                                                     }

                                   :card-footer      {:show-footer? true
                                                      :content-type :icons ; :avatar ||:tags || :icons
                                                      :content      []     ; Todo
                                                     }

                                   :card-body        {:content [:common/created-on
                                                                :task/assignee
                                                                :task/message]}}}

        default-config {:card-view card-view
                        :list-view {}
                        :map-view  {}
                        :filters   filters}]
    default-config))
